
import { ConsultationForm } from '@/components/ConsultationForm';
import { AppointmentForm } from '@/components/AppointmentForm';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface FormBlockContent {
  formId: 'consultation' | 'appointment';
  buttonText?: string;
  title?: string;
  description?: string;
}

interface FormBlockProps {
  content: FormBlockContent;
}

export const FormBlock = ({ content }: FormBlockProps) => {
  const { formId, buttonText, title, description } = content;

  const getFormComponent = () => {
    switch (formId) {
      case 'consultation':
        return <ConsultationForm />;
      case 'appointment':
        return <AppointmentForm />;
      default:
        return null;
    }
  };

  const getDefaultButtonText = () => {
    switch (formId) {
      case 'consultation':
        return 'Get Free Consultation';
      case 'appointment':
        return 'Schedule Appointment';
      default:
        return 'Contact Us';
    }
  };

  return (
    <section className="py-16 px-6">
      <div className="max-w-4xl mx-auto text-center">
        {title && (
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>
        )}
        {description && (
          <p className="text-lg text-gray-600 mb-8">{description}</p>
        )}
        
        <Dialog>
          <DialogTrigger asChild>
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700">
              {buttonText || getDefaultButtonText()}
            </Button>
          </DialogTrigger>
          {getFormComponent()}
        </Dialog>
      </div>
    </section>
  );
};
